import jDenied from '@/views/login/jDenied';

export default [
  {
    path: '/denied',
    name: 'denied',
    component: jDenied,
    meta: {
      title: 'Access Denied',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterHome.js